import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Query } from 'react-apollo'
import _ from 'lodash'
import {
  Div, H3, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/garages-components'
import { GET_GARAGE_LIST } from '../../../constants/graphql/query'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'

const { color } = theme


const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายชื่อศูนย์บริการ</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <DynamicButtonLink link='/garage/add' condition={_.includes(window.perms, PERMISSION.CREATE_GARAGE)} props={{ text: 'เพิ่มศูนย์บริการ' }}/>
      </Div>
    </Div>
    <List/>
  </Div>
)

export const List = () => {
  const [filtered, setFiltered] = useState()
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={GET_GARAGE_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            <ReactTable
              className='table'
              data={data.GarageList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              page={current}
              pages={Math.ceil(data.GarageList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  Object.assign(newOjb, { [v.id]: v.value })
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>

    </Wrapper>
  )
}
export default Index
